import { IPolygonPoint } from '../interfaces';
import { ShapeAddableElements, Shapes } from '../types';

export class ShapesFactory {

  public getShapePolygonPoints(shapeType: Shapes | ShapeAddableElements, startNumber = 0): IPolygonPoint[] {
    switch (shapeType) {
      case 'seat':
        return this.getSeatShape(startNumber);
      case 'square':
        return this.getSquareShape(startNumber);
      case 'circle':
        return this.getCircleShape(startNumber);
      case 'triangle':
        return this.getTriangleShape(startNumber);
      case 'pentagon':
        return this.getPentagonShape(startNumber);
      case 'star':
        return this.getStarShape(startNumber);
      default:
        return this.getSeatShape(startNumber);
    }
  }

  private getSeatShape(startNumber = 0): IPolygonPoint[] {
    return [
      {id: null, pointNumber: startNumber, x: 100, y: 0},
      {id: null, pointNumber: startNumber + 1, x: 100, y: 56},
      {id: null, pointNumber: startNumber + 2, x: 96, y: 72},
      {id: null, pointNumber: startNumber + 3, x: 92, y: 80},
      {id: null, pointNumber: startNumber + 4, x: 88, y: 85},
      {id: null, pointNumber: startNumber + 5, x: 84, y: 89},
      {id: null, pointNumber: startNumber + 6, x: 73, y: 95},
      {id: null, pointNumber: startNumber + 7, x: 63, y: 98},
      {id: null, pointNumber: startNumber + 8, x: 51, y: 99},
      {id: null, pointNumber: startNumber + 9, x: 49, y: 99},
      {id: null, pointNumber: startNumber + 10, x: 37, y: 98},
      {id: null, pointNumber: startNumber + 11, x: 28, y: 95},
      {id: null, pointNumber: startNumber + 12, x: 17, y: 89},
      {id: null, pointNumber: startNumber + 13, x: 12, y: 85},
      {id: null, pointNumber: startNumber + 14, x: 8, y: 80},
      {id: null, pointNumber: startNumber + 15, x: 4, y: 72},
      {id: null, pointNumber: startNumber + 16, x: 0, y: 57},
      {id: null, pointNumber: startNumber + 17, x: 0, y: 0},
    ];
  }

  private getSquareShape(startNumber = 0): IPolygonPoint[] {
    return [
      {id: null, pointNumber: startNumber, x: 0, y: 0},
      {id: null, pointNumber: startNumber + 1, x: 100, y: 0},
      {id: null, pointNumber: startNumber + 2, x: 100, y: 100},
      {id: null, pointNumber: startNumber + 3, x: 0, y: 100}
    ];
  }

  private getCircleShape(startNumber = 0): IPolygonPoint[] {
    return [
      {id: null, pointNumber: startNumber, x: 100, y: 50},
      {id: null, pointNumber: startNumber + 1, x: 97, y: 65},
      {id: null, pointNumber: startNumber + 2, x: 90, y: 79},
      {id: null, pointNumber: startNumber + 3, x: 79, y: 90},
      {id: null, pointNumber: startNumber + 4, x: 65, y: 97},
      {id: null, pointNumber: startNumber + 5, x: 50, y: 100},
      {id: null, pointNumber: startNumber + 6, x: 34, y: 97},
      {id: null, pointNumber: startNumber + 7, x: 20, y: 90},
      {id: null, pointNumber: startNumber + 8, x: 9, y: 79},
      {id: null, pointNumber: startNumber + 9, x: 2, y: 65},
      {id: null, pointNumber: startNumber + 10, x: 0, y: 50},
      {id: null, pointNumber: startNumber + 11, x: 2, y: 34},
      {id: null, pointNumber: startNumber + 12, x: 9, y: 20},
      {id: null, pointNumber: startNumber + 13, x: 20, y: 9},
      {id: null, pointNumber: startNumber + 14, x: 34, y: 2},
      {id: null, pointNumber: startNumber + 15, x: 50, y: 0},
      {id: null, pointNumber: startNumber + 16, x: 65, y: 2},
      {id: null, pointNumber: startNumber + 17, x: 79, y: 9},
      {id: null, pointNumber: startNumber + 18, x: 90, y: 20},
      {id: null, pointNumber: startNumber + 19, x: 97, y: 34}
    ];
  }

  private getTriangleShape(startNumber = 0): IPolygonPoint[] {
    return [
      {id: null, pointNumber: startNumber, x: 50, y: 0},
      {id: null, pointNumber: startNumber + 1, x: 0, y: 100},
      {id: null, pointNumber: startNumber + 2, x: 100, y: 100}
    ];
  }

  private getPentagonShape(startNumber = 0): IPolygonPoint[] {
    return [
      {id: null, pointNumber: startNumber, x: 50, y: 0},
      {id: null, pointNumber: startNumber + 1, x: 100, y: 38},
      {id: null, pointNumber: startNumber + 2, x: 82, y: 100},
      {id: null, pointNumber: startNumber + 3, x: 18, y: 100},
      {id: null, pointNumber: startNumber + 4, x: 0, y: 38}
    ];
  }

  private getStarShape(startNumber = 0): IPolygonPoint[] {
    return [
      {id: null, pointNumber: startNumber, x: 50, y: 0},
      {id: null, pointNumber: startNumber + 1, x: 61, y: 35},
      {id: null, pointNumber: startNumber + 2, x: 98, y: 35},
      {id: null, pointNumber: startNumber + 3, x: 68, y: 57},
      {id: null, pointNumber: startNumber + 4, x: 79, y: 91},
      {id: null, pointNumber: startNumber + 5, x: 50, y: 70},
      {id: null, pointNumber: startNumber + 6, x: 21, y: 91},
      {id: null, pointNumber: startNumber + 7, x: 32, y: 57},
      {id: null, pointNumber: startNumber + 8, x: 2, y: 35},
      {id: null, pointNumber: startNumber + 9, x: 39, y: 35}
    ];
  }
}
